export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fabeaae596bbb553ec489ce45a071a62ea5d1a78e&name=fetchTypeahead!'